import type { CacheExchangeOpts } from '@urql/exchange-graphcache';

const noCache = () => null;

// Auto-synced by syncCacheKeys. Custom key values are preserved, new types default to noCache.
export const keys: CacheExchangeOpts['keys'] = {
  APlus: noCache,
  AbTesting: noCache,
  AbsoluteDiscount: noCache,
  AddLastSeenResponse: noCache,
  AdditionalBrandInfo: noCache,
  AdditionalCostsInfo: noCache,
  AdditionalFlag: noCache,
  AdditionalInfo: noCache,
  AdditionalInfoVariants: noCache,
  AdditionalServicesInfo: noCache,
  Address: noCache,
  AddressInlineError: noCache,
  AddressInlineErrorMessage: noCache,
  AddressInlineErrorMessages: noCache,
  AddressWithId: noCache,
  AddressWriteable: noCache,
  AggregatedSearchFilterableAndSortableResult: noCache,
  AiGenerationMetadata: noCache,
  AlternateLocalizedLink: noCache,
  AlternateUrl: noCache,
  Amount: noCache,
  AttributeValue: noCache,
  Availability: noCache,
  AvailabilityDescription: noCache,
  AvailableVariations: noCache,
  BasicSearchAdditionalInfo: noCache,
  Basket: () => 'MyUniqueBasketId',
  BasketAPlus: noCache,
  BasketAvailability: noCache,
  BasketBanner: noCache,
  BasketBillingAddress: noCache,
  BasketLineItem: noCache,
  BasketMarketingFlag: noCache,
  BasketMessage: noCache,
  BasketMessages: noCache,
  BasketOverwrittenPrice: noCache,
  BasketPowerEfficiencyFlag: noCache,
  BasketPowerSupply: noCache,
  BasketPriceModification: noCache,
  BasketPriceSaving: noCache,
  BasketProduct: noCache,
  BasketProductPrice: noCache,
  BasketService: noCache,
  BasketServiceCluster: noCache,
  BasketServiceCount: noCache,
  BasketShippingAddress: noCache,
  Bonuspoints: noCache,
  Brand: noCache,
  BrandRecommendation: noCache,
  BrandsResult: noCache,
  Breadcrumb: noCache,
  BreadcrumbData: noCache,
  BreadcrumbItem: noCache,
  BreadcrumbSchema: noCache,
  CacheStats: noCache,
  CategoryFailureResult: noCache,
  CategoryFilterSelection: noCache,
  CategoryNotFoundResult: noCache,
  CategoryRecommendation: noCache,
  CategoryResult: noCache,
  ChangeCustomerResultWithAddressBookAndOptions: noCache,
  ChangeOrderableBasket: noCache,
  ChargingPower: noCache,
  CheckCreditCheckDetailDataResult: noCache,
  CheckoutAPlus: noCache,
  CheckoutAdditionalFlag: noCache,
  CheckoutAmount: noCache,
  CheckoutAvailability: noCache,
  CheckoutBanner: noCache,
  CheckoutBasket: noCache,
  CheckoutBillingAddress: noCache,
  CheckoutCallcenter: noCache,
  CheckoutChangeOrderableBasket: noCache,
  CheckoutChangedOrderableBasket: noCache,
  CheckoutCheckCreditCheckDetailDataResult: noCache,
  CheckoutCoupon: noCache,
  CheckoutCustomerInformation: noCache,
  CheckoutDeliveryOnDemandDate: noCache,
  CheckoutDeliveryOnDemandDatesResult: noCache,
  CheckoutDeliveryServiceTimeSlotId: noCache,
  CheckoutDirectDebitSelected: noCache,
  CheckoutGetOrderSuccess: noCache,
  CheckoutGrantSepaDirectDebitAuthorisationResultData: noCache,
  CheckoutLineItem: noCache,
  CheckoutLineItemExtraData: noCache,
  CheckoutLoyaltyProgram: noCache,
  CheckoutLoyaltyProgramPromotionCode: noCache,
  CheckoutMarketingFlag: noCache,
  CheckoutMessage: noCache,
  CheckoutMessageCustomer: noCache,
  CheckoutMessages: noCache,
  CheckoutMessagesCustomer: noCache,
  CheckoutOrderConfirmation: noCache,
  CheckoutOrderConfirmationBalanceWarning: noCache,
  CheckoutOrderConfirmationBalanceWarningPaylink: noCache,
  CheckoutOrderConfirmationExtra: noCache,
  CheckoutOrderConfirmationPaylink: noCache,
  CheckoutOrderableBasket: (data) => (typeof data.basketId === 'string' ? data.basketId : null),
  CheckoutOrderableBasketActionResultData: noCache,
  CheckoutOrderableBasketAllowedPayments: noCache,
  CheckoutOrderableBasketAllowedPremiumServiceOptions: noCache,
  CheckoutOrderableBasketBanners: noCache,
  CheckoutOrderableBasketExtra: noCache,
  CheckoutOrderableBasketLoyaltyProgram: noCache,
  CheckoutOrderableBasketTotals: noCache,
  CheckoutOrderableProduct: noCache,
  CheckoutOverwrittenPrice: noCache,
  CheckoutOverwrittenServicePrice: noCache,
  CheckoutParcelShopAddress: noCache,
  CheckoutParcelShopLocation: noCache,
  CheckoutParcelShopLocationAddress: noCache,
  CheckoutParcelShopLocationOpeningHours: noCache,
  CheckoutParcelShopLocationResponse: noCache,
  CheckoutPaymentSettings: noCache,
  CheckoutPlaceOrderFailure: noCache,
  CheckoutPlaceOrderPaypage: noCache,
  CheckoutPlaceOrderSuccess: noCache,
  CheckoutPowerEfficiencyFlag: noCache,
  CheckoutPowerSupply: noCache,
  CheckoutPriceModification: noCache,
  CheckoutPriceSaving: noCache,
  CheckoutProduct: noCache,
  CheckoutProductConfiguration: noCache,
  CheckoutProductDiscount: noCache,
  CheckoutProductPrice: noCache,
  CheckoutRevokeSepaDirectDebitAuthorisationResultData: noCache,
  CheckoutSaveSepaBankAccountResultData: noCache,
  CheckoutServerFailure: noCache,
  CheckoutService: noCache,
  CheckoutServiceCluster: noCache,
  CheckoutServiceCount: noCache,
  CheckoutShippingAddress: noCache,
  CheckoutShippingCost: noCache,
  CheckoutShippingCostVariations: noCache,
  CheckoutSimpleProductPrice: noCache,
  CheckoutTermsAndConditions: noCache,
  CheckoutTimeSlot: noCache,
  CheckoutTireEfficiencyFlag: noCache,
  CheckoutTokens: noCache,
  CheckoutTotals: noCache,
  CheckoutVerifiedPurchaseSuccess: noCache,
  CliplisterData: noCache,
  Cluster: noCache,
  CompleteVariationGroup: noCache,
  Countdown: noCache,
  Coupon: noCache,
  CriteoPlacementBeacon: noCache,
  CriteoProductsResponse: noCache,
  CustomFlag: noCache,
  CustomerAddress: noCache,
  CustomerAddressBookResult: noCache,
  CustomerAddressInlineError: noCache,
  CustomerAddressInlineErrorMessage: noCache,
  CustomerAddressInlineErrorMessages: noCache,
  CustomerAddressOnly: noCache,
  CustomerAddressWithId: (data) => data.id as string,
  CustomerAddressWriteable: noCache,
  CustomerAmount: noCache,
  CustomerAplusService: noCache,
  CustomerBooking: noCache,
  CustomerBookingsResult: noCache,
  CustomerCancelOrderResultData: noCache,
  CustomerChangeBirthDayReturnPayload: noCache,
  CustomerChangeCustomerResultWithAddressBookAndOptions: noCache,
  CustomerChangeCustomerResultWithTokens: noCache,
  CustomerChangeEmailAddressReturnPayload: noCache,
  CustomerCheckMailResponseData: noCache,
  CustomerData: noCache,
  CustomerDataWithStatus: noCache,
  CustomerDirectDebitCurrent: noCache,
  CustomerForgotPasswordRequestEmailResult: noCache,
  CustomerForgotPasswordSetNewPasswordResponse: noCache,
  CustomerForgotPasswordSetNewPasswordResult: noCache,
  CustomerForgotPasswordValidateTokenResponse: noCache,
  CustomerGenerationResult: noCache,
  CustomerGenericSuccessResult: noCache,
  CustomerIdentified: noCache,
  CustomerInfo: noCache,
  CustomerInformation: noCache,
  CustomerInvoice: noCache,
  CustomerInvoiceDocumentUrlResult: noCache,
  CustomerInvoicePaymentPlanEntry: noCache,
  CustomerInvoicePriceModification: noCache,
  CustomerInvoiceProduct: noCache,
  CustomerInvoiceProductAplus: noCache,
  CustomerInvoiceProductExtra: noCache,
  CustomerInvoiceReimbursement: noCache,
  CustomerInvoiceReimbursements: noCache,
  CustomerInvoiceResult: noCache,
  CustomerInvoicesResult: noCache,
  CustomerLineItem: noCache,
  CustomerLoginResponsePayload: noCache,
  CustomerMaturities: noCache,
  CustomerMaturitiesNextMaturity: noCache,
  CustomerMessage: noCache,
  CustomerMessages: noCache,
  CustomerOrder: noCache,
  CustomerOrderResult: noCache,
  CustomerOrderShippingAddress: noCache,
  CustomerOrdersResult: noCache,
  CustomerPermissions: noCache,
  CustomerPhoneNumberWithType: noCache,
  CustomerReadOnlyCustomerDataExtra: noCache,
  CustomerReadOnlyCustomerDataPersonalCupon: noCache,
  CustomerRefreshResult: noCache,
  CustomerRegisterResponsePayload: noCache,
  CustomerReturnLabelUrlReturnPayload: noCache,
  CustomerSearchAddress: noCache,
  CustomerSearchAddressResponse: noCache,
  CustomerServerFailure: noCache,
  CustomerShipment: noCache,
  CustomerStatus: noCache,
  CustomerStatusAdvantageLink: noCache,
  CustomerStatusAdvantages: noCache,
  CustomerStatusError: noCache,
  CustomerStatusFinancialDetails: noCache,
  CustomerStatusNews: noCache,
  CustomerStatusPremiumStatus: noCache,
  CustomerStatusShipmentEntry: noCache,
  CustomerStatusShipmentProduct: noCache,
  CustomerStoredPaymentData: noCache,
  CustomerStoredPaymentDataBankAccount: noCache,
  CustomerStoredPaymentDataCreditCard: noCache,
  CustomerStoredPaymentDataDirectDebit: noCache,
  CustomerTokens: noCache,
  CustomerTrackingData: noCache,
  CustomerValidCountries: noCache,
  CustomerValidCountry: noCache,
  CustomerValidateAddressResponse: noCache,
  CustomerVerificationResult: noCache,
  CustomerVisitorTrackingInformation: noCache,
  DeepQuery: noCache,
  DefaultFilterSelection: noCache,
  Delivery: noCache,
  DeliveryData: noCache,
  DeliveryInfo: noCache,
  DeliveryServiceTimeSlotId: noCache,
  DirectDebitCurrent: noCache,
  DirectDebitSelected: noCache,
  Download: noCache,
  EcoLabel: noCache,
  EfficiencyDetails: noCache,
  EfficiencyFlag: noCache,
  EmptyCategoryResult: noCache,
  EmptySearchResult: noCache,
  ErrorResponse: noCache,
  FilterAdjustment: noCache,
  FilterValueRange: noCache,
  FlatCategoryItem: noCache,
  FlixmediaData: noCache,
  GenerationResult: noCache,
  GenericSuccessResult: noCache,
  GroupedFilterValue: noCache,
  Hint: noCache,
  Identified: noCache,
  Info: noCache,
  InstallmentData: noCache,
  InstallmentValue: noCache,
  ItemListElement: noCache,
  LandingPageResult: noCache,
  LastSeenResponse: noCache,
  LineItemExtraData: noCache,
  LoadbeeData: noCache,
  LoyaltyProgram: noCache,
  LoyaltyProgramPromotionCode: noCache,
  MagazinContent: noCache,
  ManufacturerHint: noCache,
  MarketingFlag: noCache,
  MediaAsset: noCache,
  Message: noCache,
  MessageResponse: noCache,
  Messages: noCache,
  MiraklProductResponse: noCache,
  NewTestAssignment: noCache,
  NoSpecialCaseResult: noCache,
  OdoscopeResponseData: noCache,
  Offer: noCache,
  OocvRow: noCache,
  OocvTable: noCache,
  OrderPrice: noCache,
  OrderableBasketLoyaltyProgram: noCache,
  OrderableBasketTotals: noCache,
  ParcelShopAddress: noCache,
  PaylinkAmountWithCurrency: noCache,
  PaylinkContent: noCache,
  PaylinkDoPaymentResponse: noCache,
  PaylinkError: noCache,
  PaylinkInitializeResponse: noCache,
  PaylinkPayError: noCache,
  PaylinkRedirect: noCache,
  PaylinkReturningResponse: noCache,
  PaylinkSuccess: noCache,
  PaymentSettings: noCache,
  PaymentTypes: noCache,
  PercentDiscount: noCache,
  Permissions: noCache,
  PhoneNumberWithType: noCache,
  PicalikeLooksResponse: noCache,
  PowerDelivery: noCache,
  PowerEfficiencyFlag: noCache,
  PowerSupply: noCache,
  PreviewIcon: noCache,
  PriceSaving: noCache,
  Product: (data) => data.sku as string,
  ProductConfiguration: noCache,
  ProductDimension: noCache,
  ProductDimensionRange: noCache,
  ProductDimensionValue: noCache,
  ProductDiscount: noCache,
  ProductPrice: noCache,
  ProductReco: noCache,
  ProductRecommendation: noCache,
  ProductResponse: noCache,
  ProductReviews: noCache,
  ProductReviewsItem: noCache,
  ProductReviewsOutput: noCache,
  ProductUsps: noCache,
  ProductUspsFeature: noCache,
  ProductUspsOutput: noCache,
  ProductVariation: noCache,
  PrudsysCategoryResponse: noCache,
  PrudsysProductResponse: noCache,
  QueryReduction: noCache,
  Range: noCache,
  RangeFilterSelection: noCache,
  RatingPaging: noCache,
  RatingProduct: noCache,
  RatingResult: noCache,
  RatingReview: noCache,
  RatingReviewer: noCache,
  RatingSummaryValues: noCache,
  RatingTag: noCache,
  RatingTags: noCache,
  Ratings: noCache,
  ReadOnlyCustomerDataExtra: noCache,
  ReadOnlyCustomerDataPersonalCupon: noCache,
  RecipientInformationResponse: noCache,
  RecoBrand: noCache,
  RecoBrandResponse: noCache,
  RecoBrandTracking: noCache,
  RecoCategory: noCache,
  RecoCategoryTopsellerProduct: noCache,
  RecoCategoryTracking: noCache,
  RecoProductTracking: noCache,
  RecoProductTrackingUrl: noCache,
  RedirectRequest: noCache,
  RefreshResult: noCache,
  Response: noCache,
  ReviewStatistic: noCache,
  ReviewTag: noCache,
  ReviewTags: noCache,
  SafetyHint: noCache,
  SafetyHints: noCache,
  SampleData: noCache,
  SampleEntry: noCache,
  SampleGroup: noCache,
  SearchBrand: noCache,
  SearchBrandItem: noCache,
  SearchBreadcrumbItem: noCache,
  SearchColorFilterValue: noCache,
  SearchDefaultFilter: noCache,
  SearchDefaultFilterValue: noCache,
  SearchEfficiencyFilterValue: noCache,
  SearchFilterPreset: noCache,
  SearchImageFilterValue: noCache,
  SearchPowerSupply: noCache,
  SearchProductPrice: noCache,
  SearchProductResponse: noCache,
  SearchQueryFailureResult: noCache,
  SearchRangeFilter: noCache,
  SearchRatingFilterValue: noCache,
  SearchRedirectResult: noCache,
  SearchRejectedResult: noCache,
  SearchResultDiagnostics: noCache,
  SearchResultSummary: noCache,
  SearchSelectedCategory: noCache,
  SearchTrackingInformation: noCache,
  SeoCategoryItem: noCache,
  SeoCategoryNavigation: noCache,
  SeoData: (data) => data.sku as string,
  SeoDataV2: noCache,
  SeoLink: noCache,
  SeoLinkListV2: noCache,
  SeoLinkV2: noCache,
  SerialNumberInput: noCache,
  Service: noCache,
  ShippingCost: noCache,
  ShippingCostVariations: noCache,
  SimpleProductPrice: noCache,
  SizeTableDto: noCache,
  SortingOrder: (data) => data.key as string,
  SponsoredProductData: noCache,
  SponsoredProductsTracking: noCache,
  SponsoredStylePreviewItem: noCache,
  StandardFlag: noCache,
  StoredPaymentData: noCache,
  StoredPaymentDataBankAccount: noCache,
  StoredPaymentDataCreditCard: noCache,
  StoredPaymentDataDirectDebit: noCache,
  StyleBrand: noCache,
  StylePreviewItem: noCache,
  SubscribeResponseData: noCache,
  SuccessfulSearchResult: noCache,
  SuggestionPreview: noCache,
  SuggestionPreviewSearchResult: noCache,
  Sustainability: noCache,
  TeaserImage: noCache,
  TireEfficiency: noCache,
  TireEfficiencyFlag: noCache,
  TitledSearchAdditionalInfo: noCache,
  Tokens: noCache,
  TopCategory: noCache,
  Totals: noCache,
  Unauthenticated: noCache,
  Unauthorized: noCache,
  UnitPackage: noCache,
  UspsInfo: noCache,
  VerificationResult: noCache,
  VisitorTrackingInformation: noCache,
  Wishlist: () => 'MyUniqueWishlistId',
  WishlistAvailability: noCache,
  WishlistItemExtraData: noCache,
  WishlistLineItem: noCache,
  WishlistPowerSupply: noCache,
  WishlistPrice: noCache,
  WishlistPriceSaving: noCache,
  WishlistProductEnergyEfficiency: noCache,
  WishlistTireEfficiencyLabel: noCache,
};
